var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsOptional, IsString, Matches, MaxLength, ValidateIf, } from 'class-validator';
const BERATERNUMMER_RE = /^\d{4,7}$/;
const MANDANTENNUMMER_RE = /^\d{1,5}$/;
const MONTH_DAY_RE = /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
/**
 * Body for `PATCH /office-location-datev-settings/:officeLocationId/schnittstelle`.
 *
 * Foldout 1 — "DATEV-Schnittstelle": Beraternummer + Mandantennummer (the IDs
 * the Steuerberater enters into DATEV Rechnungswesen) and the fiscal-year
 * window. FoundingDate is only required when the fiscal year does not start
 * on 01-01 — DATEV needs the founding date to disambiguate Rumpfwirtschaftsjahre.
 */
export class UpdateDatevSchnittstelleDto {
    beraternummer;
    mandantennummer;
    fiscalYearStart;
    foundingDate;
    /**
     * Justification for changing a *frozen* settings block (PRD #1319 / RS-003).
     * Required by the domain once the first export has completed; ignored
     * before the freeze. Recorded verbatim into the change history.
     */
    reason;
}
__decorate([
    IsOptional(),
    ValidateIf((_, v) => v !== null),
    Matches(BERATERNUMMER_RE, { message: 'beraternummer must be 4–7 digits' }),
    __metadata("design:type", Object)
], UpdateDatevSchnittstelleDto.prototype, "beraternummer", void 0);
__decorate([
    IsOptional(),
    ValidateIf((_, v) => v !== null),
    Matches(MANDANTENNUMMER_RE, { message: 'mandantennummer must be 1–5 digits' }),
    __metadata("design:type", Object)
], UpdateDatevSchnittstelleDto.prototype, "mandantennummer", void 0);
__decorate([
    IsOptional(),
    Matches(MONTH_DAY_RE, { message: 'fiscalYearStart must be "MM-DD" (01-01 … 12-31)' }),
    __metadata("design:type", String)
], UpdateDatevSchnittstelleDto.prototype, "fiscalYearStart", void 0);
__decorate([
    IsOptional(),
    ValidateIf((_, v) => v !== null),
    IsDateString({}, { message: 'foundingDate must be an ISO date string' }),
    __metadata("design:type", Object)
], UpdateDatevSchnittstelleDto.prototype, "foundingDate", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(1000),
    __metadata("design:type", Object)
], UpdateDatevSchnittstelleDto.prototype, "reason", void 0);
//# sourceMappingURL=update-datev-schnittstelle.dto.js.map